export const getMenuItemsByLocation = (menuItems, targetLocation) => menuItems.reduce((accum, curr) => {
    var _a;
    if ((_a = curr.menuLocations) === null || _a === void 0 ? void 0 : _a.includes(targetLocation)) {
        accum.push(curr);
    }
    return accum;
}, []);
